import * as React from 'react';
import styled from 'styled-components';
import Container from './Container';
import Icon from './Icon';
import {Links} from './Links';
import Logo from './Logo';

const BigNav = styled.nav.attrs(() => ({className: 'white'}))`
    height: 84px;
`;

const MobileMenuIcon = () => (
    <div
        className="sidenav-trigger black-text hide-on-large-only"
        data-target="mobile-menu"
        style={{marginTop: '13px'}}
    >
        <Icon>menu</Icon>
    </div>
);

const BigItemsList = styled.ul.attrs(() => ({
    className: 'right hide-on-med-and-down',
}))`
    height: 84px;
    line-height: 84px;
`;

const NavBarLogo = styled(Logo)`
    margin-top: 5px;
`;

const MobileMenuLogo = styled(Logo)`
    padding: 15px;
`;

const NoPaddingLink = styled.a`
    padding: 0 !important;
`;

const NavBar = ({showLogo}) => (
    <>
        <BigNav>
            <NavWrapper className="container nav-wrapper">
                {showLogo ? (
                    <a href="/" className="brand-logo grey-text text-darken-3" aria-label="Jodi Franklin">
                        <NavBarLogo width="200" dark />
                    </a>
                ) : null}
                <MobileMenuIcon />
                <BigItemsList className="right hide-on-med-and-down">
                    <Links />
                </BigItemsList>
            </NavWrapper>
        </BigNav>

        <ul className="sidenav" id="mobile-menu">
            <NoPaddingLink href="/" className="grey-text text-darken-3">
                <MobileMenuLogo width="100%" dark />
            </NoPaddingLink>
            <Links />
        </ul>
    </>
);

export default NavBar;

const NavWrapper = styled.div`
    @media only screen and (max-width: 1300px) {
        width: 90%;
    }
`;
